<section class="support-journey-section" *ngIf="!userLoggedIn" style="background-image: url('assets/images/home/hiwbg.png')">
  <div class="container-fluid container-max">
    <!-- Central Hero Area with Text, Overlapping Bike, and Badge -->
    <div class="journey-hero">
      <!-- Big Bold Background Heading -->
      <h1 class="journey-title hf">
        <span class="title-line f180">HOW WE SUPPORT</span>
        <span class="title-line f180">YOUR JOURNEY</span>
      </h1>

      <!-- Floating Jumping Bike Rider -->
      <div class="bike-wrap">
        <img src="assets/images/home/bike.png" alt="Dirt Bike Rider" class="bike-img" />
      </div>

      <!-- Rotating Circle Badge Stamp -->
      <div class="circular-stamp-wrap">
        <div class="circular-stamp">
          <svg viewBox="0 0 100 100" class="stamp-svg">
            <path id="circlePath" d="M 50, 50 m -38, 0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" fill="none" />
            <text class="stamp-text">
              <textPath href="#circlePath" startOffset="0%">JOIN XDGE AND START TRACKING • JOIN XDGE AND START TRACKING •</textPath>
            </text>
          </svg>
          <div class="stamp-center">
            <svg
              viewBox="0 0 24 24"
              class="stamp-arrow"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="square"
              stroke-linejoin="miter"
            >
              <line x1="7" y1="17" x2="16" y2="8"></line>
              <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Features Section (3 columns using bootstrap grid) -->
    <div class="row journey-features pt-5">
      <!-- Feature 01 -->
      <div class="col-12 col-md-4 mb-5 mb-md-0">
        <div class="feature-item">
          <span class="feature-index hf f40">01</span>
          <h3 class="feature-item-title hf f40">UNLEASH YOUR POTENTIAL</h3>
          <p class="feature-item-desc f18">
            Log your sports, earn your scores, and climb the XDGE leaderboard. Every score is verified, and progress is motivated by community
            support.
          </p>
        </div>
      </div>

      <!-- Feature 02 -->
      <div class="col-12 col-md-4 mb-5 mb-md-0">
        <div class="feature-item">
          <span class="feature-index hf f40">02</span>
          <h3 class="feature-item-title hf f40">WEAR THE UNIFORM</h3>
          <p class="feature-item-desc f18">Your rank is earned here. Your gear reflects your level of experience and commitment to extreme sports.</p>
        </div>
      </div>

      <!-- Feature 03 -->
      <div class="col-12 col-md-4">
        <div class="feature-item">
          <span class="feature-index hf f40">03</span>
          <h3 class="feature-item-title hf f40">STAY UPDATED ON EVENTS</h3>
          <p class="feature-item-desc f18">Get notified of upcoming events and create your own events. Make the most of this community.</p>
        </div>
      </div>
    </div>
  </div>
</section>
